const LEADERBOARD_DATE_FORMATTER = new Intl.DateTimeFormat(undefined, {
  day: "numeric",
  hour: "numeric",
  minute: "2-digit",
  month: "short",
});

export function formatLeaderboardDate(value) {
  if (!value) {
    return "";
  }

  const date = new Date(value);
  if (Number.isNaN(date.getTime())) {
    return "";
  }

  return LEADERBOARD_DATE_FORMATTER.format(date);
}
